import React from 'react'
import _ from 'lodash'

import {Row, Col} from 'react-flexbox-grid'
import {Link} from 'react-router'
import {Alert, Button, Icon} from 'antd'

import {DeviceService} from 'api/device'

import {Form, Input, Select, Submit} from 'forms'
import {AddressEncoder} from 'ui'
import {parse as decodeAddress} from 'util/address.js'

export class CreateDevice extends React.Component {
   static get propTypes() {
      return {
         network:  React.PropTypes.object,
         router:   React.PropTypes.object,
         location: React.PropTypes.object
      }
   }

   constructor() {
      super()
      this.state = {
         creating: false,
         error:    false
      }

      this.handleSubmit = this.handleSubmit.bind(this)
   }

   componentDidMount() {
      this._mounted = true
   }

   componentWillUnmount() {
      this._mounted = false
   }

   handleSubmit(ev, patch) {
      const {network, location, router} = this.props,
         basepath = location.pathname.split('/').slice(0, -1).join('/')

      ev.preventDefault()

      this.setState({creating: true, error: false})

      return DeviceService.create(network.key, patch)
         .then(resp => {
            this.setState({creating: false, error: false})

            router.push({...location, pathname: basepath})

            return resp
         })
         .catch(resp => {
            if (resp.req && 201 !== resp.req.status) {
               let error =
                  resp.data.error || resp.data.message || JSON.stringify(resp.data, null, 2)

               this.setState({
                  creating: false,
                  error
               })
            } else {
               this.setState({creating: false, error: resp})
            }
         })
   }

   get Form() {
      const defaultError = 'There was an error creating your Gateway, try creating it manually.'

      return ({network, location}) => {
         let basepath = location.pathname.split('/').slice(0, -1).join('/')

         console.log('error', this.state.error)

         return (
            <div>
               <div className="page-header">
                  <h1>Create new device</h1>
               </div>

               {this.state.error &&
                  false === this.state.creating &&
                  <Alert
                     type="error"
                     message={
                        <div>
                           <b>An error occured</b><br />
                           {_.isString(this.state.error) ? this.state.error : defaultError}
                        </div>
                     }
                  />}

               <Form
                  defaultValues={{address: '::0', type: _.get(network, 'provision.type')}}
                  transform={({address, ...rest}) => _.set(rest, 'address', decodeAddress(address))}
                  onSubmit={this.handleSubmit}
               >

                  <Form.Updated>Network was successfully updated</Form.Updated>
                  <Form.Error>Some error occurred during submit</Form.Error>

                  <Input param="name" label="Name" />

                  <Input
                     param="address"
                     label="Address"
                     groupCssClass="feedback-inline"
                     validate={n => {
                        if (!_.isNumber(decodeAddress(n)) || isNaN(decodeAddress(n))) {
                           return {error: 'Invalid address'}
                        }

                        return true
                     }}
                     feedback={({value, error}) => {
                        let parsedValue = decodeAddress(value || '0')

                        return (
                           <span className="help-block">
                              {error
                                 ? error
                                 : <AddressEncoder
                                      pretty={true}
                                      value={decodeAddress(parsedValue)}
                                   />}
                           </span>
                        )
                     }}
                  />

                  <Select param="type" label="Device Type" options={network.types} />

                  <hr style={{margin: '2em 0 1em'}} />

                  <div className="text-right" style={{width: '100%'}}>
                     <Submit icon="save">
                        Create Device
                     </Submit>
                     &nbsp;
                     <Button type="dashed">
                        <Link to={{...location, pathname: basepath}}>
                           <Icon type="close" /> Cancel
                        </Link>
                     </Button>
                  </div>
               </Form>
            </div>
         )
      }
   }

   render() {
      const {error} = this.state,
         {network, location} = this.props,
         InnerForm = this.Form

      return (
         <Row>
            <Col md={12}>
               <InnerForm location={location} error={error} network={network} />
            </Col>
         </Row>
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/network/device-manager/CreateDevice.jsx